import React from 'react'
//import { withRouter } from 'react-router-dom'

class Lab extends React.Component {
  render () {
    return (
      <div className='home'>
        <div className='render-body'>
          <div className='iframe-container'>
              This is Lab Page
          </div>
        </div>
      </div>
    )
  }
}

//export default withRouter(Lab)
export default Lab
